import { action as apiAction } from 'api/Api'

type Payload = {
  documentListId: number
  documentSourceId: number
  url: string
}

export default (payload: Payload) => async () => {
  const { documentListId, url, documentSourceId } = payload

  try {
    await apiAction('AddDocumentsListItem', {
      containerId: documentListId,
      url,
      documentsSourceId: documentSourceId,
      position: 0
    })
  } catch (error) {
    if (error.code !== 300) { // Duplicate
      throw error
    }
  }
}
